@import 'src/global/media_queries'
  
:host 
  display: block

  @include media("<tablet")
    width: 100% !important
    margin: 0 !important

  @include media(">=tablet")
    margin: 0.5rem 1rem

.button-wrapper.variant-simple
  width: 100%
  max-width: 20rem
  padding: 2rem 3rem
  margin: 0.5rem auto
  background: var(--background-color)
  border-radius: 0.5rem

  &.sold-out
    position: relative
    opacity: 0.5
    pointer-events: none

    & *
      pointer-events: none

  .price
    font-size: var(--fs-2xl)
    font-weight: 700
    color: var(--color)
    margin-bottom: 1rem
    text-transform: lowercase

  .operator
    display: flex
    flex-direction: row-reverse
    justify-content: center
    align-items: center

    .operator-quantity
      width: 2rem
      text-align: center
      font-size: var(--fs-l)
      font-weight: 700
      color: var(--color)

    button
      width: 2rem
      height: 2rem
      margin: 0.2rem
      display: flex
      justify-content: center
      align-items: center
      font-size: 1.5rem
      font-weight: 900
      color: var(--contrast-color)
      background-color: var(--contrast-background-color)
      border-radius: 0.5rem
      cursor: pointer
      transition: transform 0.1s linear

      &:hover
        transform: scale(1.05)
  
.button-wrapper.variant-card
  --border-radius: 0.4rem
  width: 100%
  max-width: 20rem
  padding: 0.3rem
  margin-top: calc(0.4rem + var(--label-padding))
  margin-bottom: 0.4rem
  margin-left: auto
  margin-right: auto
  display: flex
  justify-content: space-between
  align-items: center
  position: relative
  color: var(--color)
  background-color: var(--background-color)
  border-radius: var(--border-radius)

  @include media(">=tablet")
    --border-radius: 1.5rem
    width: 12rem
    padding: 0
    margin-top: 0.6rem
    flex-direction: column
    background-color: var(--contrast-background-color)

  & > *:not(.label) 
    justify-self: center
    align-self: center
    padding: 0.3rem
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center

    @include media(">=tablet")
      width: 100%

      &.price,
      &.quantity
        padding-top: 1rem

      &.operator,
      &.total
        padding-bottom: 1rem

      &.quantity,
      &.total
        color: var(--contrast-color)

  .desc
    font-size: var(--fs-sm)
    font-weight: 600
    white-space: nowrap

    @include media(">=tablet")
      font-size: var(--fs-s)

  .value
    font-weight: 900

    &.ticket-value,
    &.quantity-value
      line-height: 0.9
      font-size: var(--fs-4xl)
      letter-spacing: -0.2rem

    &.total-value
      font-size: var(--fs-2xl)
      letter-spacing: -0.05rem

    @include media(">=tablet")
      &.quantity-value,
      &.total-value
        font-size: var(--fs-xl)
        padding: 0 0.2rem

  .label
    display: block
    padding: 0.4rem 0.8rem
    position: absolute
    top: -1rem
    left: 50%
    transform: translate(-50%, 0)
    font-family: var(--ff-pragati)
    font-size: var(--fs-m)
    font-weight: 900
    background-color: #000
    border-radius: 0.4rem

    @include media(">=tablet")
      top: -1.5rem
      left: unset
      transform: unset

  .price
    grid-area: price
    order: 1

    .ticket-value
      font-size: var(--fs-4xl)

    @include media(">=tablet")
      background-color: var(--background-color)
      border-radius: var(--border-radius) var(--border-radius) 0 0

      .ticket-value
        font-size: var(--fs-5xl)

      .desc
        font-size: var(--fs-m)

  .operator
    grid-area: operator
    order: 4
    position: relative

    @include media(">=tablet")
      flex-direction: row-reverse
      order: 2
      background-color: var(--background-color)
      border-bottom-right-radius: var(--border-radius)
      top: -1px
    
    & > *
      width: 2.5rem
      height: 2rem
      margin: 0.2rem
      display: flex
      justify-content: center
      align-items: center
      font-size: 1.5rem
      font-weight: 900
      color: var(--contrast-color)
      background-color: var(--contrast-background-color)
      border-radius: 0.2rem
      cursor: pointer
      transition: transform 0.1s linear

      &:hover
        transform: scale(1.05)

  .quantity
    grid-area: quantity
    order: 2

    @include media(">=tablet")
      flex-direction: row

  .total
    grid-area: total
    order: 3

  &.sold-out
    position: relative
    opacity: 0.5
    pointer-events: none

    & *
      pointer-events: none

